import { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { normalizeForFuzzy, isCloseMatch } from "../../../Utils/aiUtils";

const MultiSelectDropdown = ({ items, selectedOptions, onChange, name }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleCheckboxChange = (option) => {
    const updatedOptions = [...selectedOptions];
    const index = updatedOptions.indexOf(option);
    if (index === -1) {
      updatedOptions.push(option);
    } else {
      updatedOptions.splice(index, 1);
    }
    onChange(updatedOptions);
  };

  const filteredItems = items?.filter((item) => {
    const label = (item.name || item.label || "").toLowerCase();

    // If search is short, do strict matching
    if (searchTerm.length < 2) {
      return label.includes(searchTerm.toLowerCase());
    }

    // Smart fuzzy matching & typo tolerance (via utility)
    return isCloseMatch(searchTerm, label);
  });

  return (
    <Dropdown className="w-100 h-100">
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className="w-100 h-100 border-0 bg-transparent text-primary d-flex align-items-center justify-content-center shadow-none"
      >
        {name}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "200px" }} className="p-0 overflow-hidden">
        <div className="px-2 py-2 border-bottom bg-white">
          <Form.Control
            size="sm"
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
            className="shadow-none border-0 bg-light"
          />
        </div>
        <div style={{ maxHeight: "250px", overflowY: "auto" }} className="py-2">
          <Form className="px-3">
            <Form.Group>
              {filteredItems?.length > 0 ? (
                filteredItems.map((item) => (
                  <Form.Check
                    key={item.value}
                    type="checkbox"
                    id={`checkbox-${item.value}`}
                    label={item.name || item.label}
                    className="py-1"
                    checked={selectedOptions.includes(item.value)}
                    onChange={() => handleCheckboxChange(item.value)}
                  />
                ))
              ) : (
                <div className="text-center text-muted py-2">No results</div>
              )}
            </Form.Group>
          </Form>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiSelectDropdown;
